const searchBarTrigger = () => {
    const searchToggle = document.querySelector(".site-header__toggle-search svg");
    const searchToggleMobile = document.querySelector(".site-header__toggle-search i");
    const SearchInput = document.querySelector(".site-header-searchbar__form input[type='text']");
    const searchBar = document.querySelector(".site-header-searchbar");
    const searchBarMobile = document.querySelector(".site-header-searchbar.--mobile");

    const isSanita = document.body.classList.contains("sanita");

    const breakpoint = {
        desktop: 1199
    }
    const isDesktop = window.innerWidth > breakpoint.desktop;
    if(isSanita){
        const searchToggles = document.querySelectorAll(".site-header__toggle-search");
        const searchInput = document.querySelector(".algolia-searchbox__input input");
        
        searchToggles.forEach(element => {
            element.addEventListener('click', (e) =>{   
                searchBar.classList.toggle("visible"); 
                e.target.classList.toggle('active');
                document.body.classList.toggle("overflow-hidden");
                searchInput.focus()
            });  
        });
    }else{
        if(isDesktop){
            searchToggle.addEventListener('click', (e) =>{   
                searchBar.classList.toggle("visible"); 
                e.target.classList.toggle('active');
                SearchInput.focus();
                if(isSanita){
                    document.body.classList.toggle("overflow-hidden")
                }
                
            });   
            if(isSanita){
                searchToggleMobile.addEventListener('click', (e) =>{  
                    searchBar.classList.toggle("visible") 
                    searchBarMobile.classList.toggle("visible"); 
                    e.target.classList.toggle('active');
                    document.body.classList.toggle("overflow-hidden")
                    
                }); 
            }
            /* CLICK OUTSIDE TO CLOSE SEARCHBAR */
            window.addEventListener('mouseup', function(e){  
                // se elemento su cui clicco è diverso da: searchbar, da search-toggle e searchbar contiene la classe visible
                if (!searchBar.contains(e.target) &&  e.target != searchToggle && searchBar.classList.contains('visible')){
                    searchBar.classList.remove("visible");
                    document.body.classList.remove("overflow-hidden")
                } 
                
            });
        }else{
            searchToggleMobile.addEventListener('click', (e) =>{   
                searchBarMobile.classList.toggle("visible"); 
                e.target.classList.toggle('active');
                if(isSanita){
                    document.body.classList.toggle("overflow-hidden")
                }
            });   
            /* CLICK OUTSIDE TO CLOSE SEARCHBAR */
            window.addEventListener('mouseup', function(e){  
                // se elemento su cui clicco è diverso da: searchbar, da search-toggle e searchbar contiene la classe visible
                if (!searchBarMobile.contains(e.target) &&  e.target != searchToggleMobile && searchBarMobile.classList.contains('visible')){
                    searchBarMobile.classList.remove("visible");
                    searchToggleMobile.classList.remove("active"); 
                } 
                
            });
        }
    }
    
}
const submenuTabs = () => {
    let tabsNavi = jQuery(".megamenu-tabs-navi li");
    tabsNavi.on('mouseenter',function(){
        let indice = jQuery(this).index();
        jQuery(this).parents(".megamenu").find(".megamenu-tabs-navi li").removeClass("active");
        jQuery(this).addClass("active");
        jQuery(this).parents(".megamenu").find(".megamenu-tabs-content__item").removeClass('active');
        jQuery(this).parents(".megamenu").find(".megamenu-tabs-content__item").eq(indice).addClass('active');
    });
}

const clearSearch = () => {
    const searchClear = document.querySelector(".site-header-searchbar__clear");
    const searchInput = document.querySelector(".site-header-searchbar__input");
    const searchForm = document.querySelector(".site-header-searchbar__form");
    searchClear.addEventListener('click', () =>{
        searchInput.value = "";
        searchForm.target.reset();
    });
}

const mobileMenuTrigger = () => {
    const mobileMenuButton = document.querySelector(".site-header__toggle-menu");
    const mobileContactsTrigger = document.querySelector(".site-header__toggle-contacts");
    const mobileContacts = document.querySelector(".site-header__contacts");
    const mobileMenu = document.getElementById("mobileMenu");

    
    mobileMenuButton.addEventListener('click', () =>{
        document.body.classList.toggle("overflow-hidden")
        document.body.classList.toggle("overlay-mask");
        mobileContacts.classList.remove('show');
    });
    mobileContactsTrigger.addEventListener('click', () =>{
        mobileMenu.classList.remove('show');
        mobileMenuButton.classList.add('collapsed');
        document.body.classList.toggle("overflow-hidden")
        document.body.classList.toggle("overlay-mask");
    });

    /* CLICK OUTSIDE TO CLOSE SEARCHBAR */
    window.addEventListener('mouseup', function(e){  
        // se elemento su cui clicco è diverso da: searchbar, da search-toggle e searchbar contiene la classe visible
        if (!mobileContacts.contains(e.target) && !mobileContactsTrigger.contains(e.target) && e.target != mobileContacts && e.target != mobileContactsTrigger && mobileContacts.classList.contains('show')){
            document.body.classList.remove("overflow-hidden")
            document.body.classList.remove("overlay-mask");
            mobileContacts.classList.remove('show');
            mobileContactsTrigger.classList.add('collapsed');
        } 
        
    });
    
}


const Header = () => {
    if(document.querySelector(".site-header-searchbar")){
        searchBarTrigger();
    }
    if(document.querySelector(".megamenu-tabs-navi")){
        submenuTabs();
    }
    if(document.querySelector(".site-header-searchbar__clear")){
        clearSearch();
    }
    if(document.querySelector(".site-header--mobile")){
        mobileMenuTrigger();
    }
    
}

export default Header;